import React, { useState } from 'react';
import { Accordion, AccordionItem, AccordionHeader, AccordionBody } from 'reactstrap';
import styles from './FAQ.module.scss';

const FAQ = ({ faqs, displayArea }) => {
  const [open, setOpen] = useState(null); // To manage which item should be opened at first

  const toggle = (id) => {
    if (open === id) {
      setOpen('');
    } else {
      setOpen(id);
    }
  };

  const filteredFaqs = faqs?.filter(faq => faq.displayArea === displayArea);

  return (
    <div className={styles.faqsContainer}>
      <Accordion open={open} toggle={toggle}>
        {filteredFaqs?.map((faq, index) => (
          <AccordionItem key={index} className={styles.faqItem}>
            <AccordionHeader targetId={`${index}`} className={styles.accordionHeader}>
              {faq.question}
            </AccordionHeader>
            <AccordionBody accordionId={`${index}`} className={styles.accordionBody}>
              {faq.answer}
            </AccordionBody>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default FAQ;
